import Vue from 'vue'
import router from './router/router-mod'
import axios from 'axios'
import Axios from '@/axios'
import store from './store'
import MintUI from 'mint-ui'
import './style/new-style.scss'
import 'mint-ui/lib/style.css'
import './style/mode.scss'
import './style/change.scss'
import './js/mobile-util.js'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import Message from 'muse-ui-message'
import 'muse-ui-message/dist/muse-ui-message.css'
import 'animate.css'
import './assets/font/material-icons.css'
import App from './App.vue'
//头像裁剪插件
import clipper from './../static/clipper.js'

import noneImg from './components/none'

Vue.component('noneImg', noneImg)

Vue.config.productionTip = true
Vue.use(clipper)
Vue.use(MintUI)
Vue.use(MuseUI).use(Message)
import jquery from 'jquery'

Vue.prototype.$ = jquery

Vue.prototype.$axios = axios
Vue.prototype.$Axios = Axios
// axios.defaults.baseURL = 'http://wbstapi.ewangke.com/v1/'
axios.defaults.baseURL = 'http://wbstapi.ewangke.com/v1/'

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})








// WEBPACK FOOTER //
// ./src/main.js